import jQuery from 'jquery';

const setupFetchUserInfo = ({
  baseURL = window.location.origin,
  objectType = undefined,
  documentId = undefined,
  getAuthorization = undefined,
} = {}) => {
  const userIdMap = {};

  return function fetchUserInfo(userInfo, cancelToken) {
    const { userId } = userInfo;
    let xhr = null;

    if (cancelToken) {
      cancelToken.cancel = () => {
        if (xhr) {
          xhr.abort();
        }
      };
    }

    return new Promise((resolve, reject) => {
      let userURL;
      if (objectType === 'Note' && documentId) {
        // Notes may be shared outside of an account, so we need to
        // find users among all users collaborating on a note.
        userURL = `${baseURL}/api/v1/notes/${documentId}/users/${userId}.json`;
      } else {
        userURL = `${baseURL}/api/v1/users/${userId}.json?fields=name`;
      }

      const authorization = getAuthorization && getAuthorization();

      const headers = authorization
        ? { Authorization: `Bearer ${authorization}` }
        : {};

      if (userIdMap[userId]) {
        resolve({ displayName: userIdMap[userId] });
      } else {
        xhr = jQuery.get({ url: userURL, headers }, json => {
          const displayName = json.user.name;
          userIdMap[userId] = displayName;
          resolve({ displayName });
        });
      }
    });
  };
};

export default setupFetchUserInfo;
